export const getSessionStorageItem = (key: string, clearOnFailure = true): unknown => {
  const storedData = sessionStorage.getItem(key);

  if (!storedData) {
    return null;
  }

  try {
    return JSON.parse(storedData) as unknown;
  } catch {
    console.error('Failed to parse stored data from session storage');
    if (clearOnFailure) {
      console.log('Clearing old data...');
      removeSessionStorageItem(key);
    }
  }

  return null;
};

export const setSessionStorageItem = (key: string, data: unknown): void => {
  try {
    sessionStorage.setItem(key, JSON.stringify(data));
  } catch {
    console.error('Failed to store data in session storage');
  }
};

export const removeSessionStorageItem = (key: string): void => {
  sessionStorage.removeItem(key);
};
